import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Close } from '@mui/icons-material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { BsBell, BsMegaphone } from 'react-icons/bs';
import { COLORS } from 'shared/constants/AppEnums'
import { alpha, Badge, Divider, IconButton, Stack, Tab, Typography } from '@mui/material';
import Notifikasi from './Notifikasi'
import Pengumuman from './Pengumuman';
import { useSelector } from 'react-redux';

const AppNotificationContent = ({ onClose, sxStyle }) => {
  const [tabValue, setTabValue] = useState('notifikasi');
  const [notificationData] = useSelector(({ portal }) => [portal.notifications]);

  const handleChangeTabValue = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <TabContext value={tabValue}>
      <Stack spacing={2}>
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} px={4} py={2}>
          <Stack>
            <Typography variant='h3' fontWeight={600}>Pusat Pemberitahuan</Typography>
          </Stack>

          <Stack>
            <IconButton
              sx={{
                width: 30,
                height: 30
              }}
              onClick={onClose}
            >
              <Close sx={{ width: 16, height: 16 }} />
            </IconButton>
          </Stack>
        </Stack>

        <Divider />

        <Stack px={4}>
          <TabList
            onChange={handleChangeTabValue}
            aria-label="lab API tabs example"
            variant='fullWidth'
            TabIndicatorProps={{
              style: {
                backgroundColor: 'transparent',
              }
            }}
            sx={{
              minHeight: '0 !important',
              '& .MuiTabPanel-root': {
                padding: '0 !important'
              },
              '& .Mui-selected': {
                color: `${COLORS.primary} !important`,
                fontWeight: 500,
                backgroundColor: alpha(COLORS.primary, 0.2)
              },
              '& .MuiButtonBase-root.MuiTab-root': {
                fontSize: 16,
                paddingY: '16px !important',
                paddingX: '16px !important',
                textTransform: 'capitalize',
                minWidth: '0 !important',
                borderRadius: 4
              },
              '& .MuiTabs-flexContainer': {
                gap: 0
              }
            }}
          >
            <Tab label="Notifikasi" icon={<Badge badgeContent={notificationData?.counter?.unread_count ?? 0} color='error'><BsBell size={20} /></Badge>} iconPosition='end' value="notifikasi" disableRipple sx={{ height: 'auto', minHeight: '10px' }} />
            <Tab label="Pengumuman" icon={<BsMegaphone size={20} />} iconPosition='end' value="pengumuman" disableRipple sx={{ height: 'auto', minHeight: '10px' }} />
          </TabList>
        </Stack>

        <Divider />

        <TabPanel sx={{ padding: '0 !important' }} value="notifikasi">
          <Stack>
            <Notifikasi onCloseNotification={onClose}/>
          </Stack>
        </TabPanel>

        <TabPanel sx={{ padding: '0 !important' }} value="pengumuman">
          <Stack>
            <Pengumuman />
          </Stack>
        </TabPanel>
      </Stack>
    </TabContext>
  );
};

export default AppNotificationContent;

AppNotificationContent.propTypes = {
  onClose: PropTypes.func,
  sxStyle: PropTypes.object,
};
